module.exports = __webpack_public_path__ + "static/media/25.69bf951a.svg";